export const branchesSliceName = "branches"

// The global header selector's "All branches" value — a sentinel, never a
// real Team id, so it can share the same string field as a branch id.
export const ALL_BRANCHES = "all"
